<template>
  <h1 class="page-title breadcrumb-title">
    <router-link :to="{ name: 'deleted' }" v-if='computedBreadcrumbs.length > 0'>
      {{ $t('root.deleted_data') }}
    </router-link>

    <div v-else>
      {{ $t('root.deleted_data') }}
    </div>

    <div class="dropdown" v-if='hiddenBreadcrumbs.length > 0'>
      >
      <button aria-expanded="false" aria-haspopup="true" data-toggle="dropdown" type="button" class="btn dropdown-toggle">· · ·</button>
      <div class="dropdown-menu">
        <ul>
          <li v-for='f in hiddenBreadcrumbs' :key='f.id'>
            <router-link :to="{ name: 'deleted_show', params: { id: f.id } }">
              <i class="fas fa-folder"></i>
              {{ f.name }}
            </router-link>

            <router-link v-if='f.contact_id' :to="{name: 'contact_folders', params: { id: f.contact_id }}" class='contact-name'>
              {{ `(${f.contact_name})` }}
            </router-link>
          </li>
        </ul>
      </div>
    </div>

    <div v-for='f in remainingBreadcrumbs' :key='f.id'>
      >
      <router-link :to="{ name: 'deleted_show', params: { id: f.id } }">
        {{ f.name }}
      </router-link>

      <router-link v-if='f.contact_id' :to="{name: 'contact_folders', params: { id: f.contact_id }}" class='contact-name'>
        {{ `(${f.contact_name})` }}
      </router-link>
    </div>

    <div v-if='lastBreadcrumb'>
      >
      {{ lastBreadcrumb.name }}

      <router-link v-if='lastBreadcrumb.contact_id' :to="{name: 'contact_folders', params: { id: lastBreadcrumb.contact_id }}" class='contact-name'>
        {{ `(${lastBreadcrumb.contact_name})` }}
      </router-link>
    </div>
  </h1>
</template>

<script>
  export default {
    props: ['breadcrumbs'],
    computed: {
      computedBreadcrumbs() {
        return this.$props.breadcrumbs || []
      },
      middleBreadcrumbs() {
        return this.computedBreadcrumbs.slice(1, this.computedBreadcrumbs.length - 1)
      },
      hasHidden() {
        return this.middleBreadcrumbs.length > 1
      },
      hiddenBreadcrumbs() {
        return this.hasHidden ? this.middleBreadcrumbs.slice(0, this.middleBreadcrumbs.length - 1) : []
      },
      remainingBreadcrumbs() {
        return this.hasHidden ? this.middleBreadcrumbs.slice(this.middleBreadcrumbs.length - 1) : this.middleBreadcrumbs
      },
      lastBreadcrumb() {
        return this.computedBreadcrumbs[this.computedBreadcrumbs.length - 1]
      },
    }
  }
</script>
